export default __webpack_public_path__ + "static/media/temp-results-img-4.a09c992f.jpg";